import { render } from "./DepartmentNode.vue?vue&type=template&id=21c7ed70&scoped=true"
import script from "./DepartmentNode.vue?vue&type=script&lang=js"
export * from "./DepartmentNode.vue?vue&type=script&lang=js"

import "./DepartmentNode.vue?vue&type=style&index=0&id=21c7ed70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c7ed70"]])

export default __exports__